/**
 * Dev-only reset helper.
 *
 * Usage (in browser console on the app):
 *   window.__resetDev()
 *
 * This wipes ALL local/session storage keys used by the app
 * and signs the user out, giving you a true blank-slate session.
 */
import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEYS = [
  "careerGPS_answers",
  "careerGPS_completed",
  "careerGPS_userName",
  "careerGPS_userFirstName",
  "careerGPS_userLastName",
  "careerGPS_userEmail",
  "careerGPS_verified",
  "careerGPS_sessionId",
  "careerGPS_confettiFired",
];

export async function resetDevEnvironment() {
  try {
    await supabase.auth.signOut();
  } catch {
    // ignore
  }

  // Clear known app keys explicitly
  STORAGE_KEYS.forEach((k) => {
    try { localStorage.removeItem(k); } catch {}
    try { sessionStorage.removeItem(k); } catch {}
  });

  // Nuke any remaining careerGPS_* / supabase auth keys
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("careerGPS_") || k.startsWith("sb-"))
      .forEach((k) => localStorage.removeItem(k));
  } catch {}
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith("careerGPS_") || k.startsWith("sb-"))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch {}

  console.log("[devReset] Cleared local/session storage and signed out.");
  console.log("[devReset] Reloading...");
  window.location.href = "/";
}

if (typeof window !== "undefined") {
  (window as any).__resetDev = resetDevEnvironment;
  // eslint-disable-next-line no-console
  console.log("[devReset] Available: run window.__resetDev() to wipe local state.");
}
